import React from 'react'

const Parks = ({ className }) => {
    return (
        <svg
            className={className}
            width="162"
            height="43"
            viewBox="0 0 162 43"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.41501 24.3627H4.00874V31.4638H0V11.4207H8.75985C12.5387 11.4207 15.6566 13.5098 15.6566 17.7791C15.6566 22.4149 12.5674 24.3627 8.41501 24.3627ZM8.61616 15.3138H4.00874V20.4696H8.67364C10.5343 20.4696 11.5353 19.6095 11.5353 17.8629C11.5353 16.114 10.3906 15.3138 8.61616 15.3138Z"
                fill="#4F5260"
            />
            <path
                d="M32.2642 31.4662L30.6885 26.9981H23.3607L21.7874 31.4662H17.4937L25.1639 11.4207H29.0601L36.6729 31.4662H32.2642ZM28.028 19.552C27.6257 18.378 27.2257 17.1753 27.0246 16.4326C26.8234 17.1753 26.4211 18.3756 26.0236 19.552L24.7329 23.1912H29.3163L28.028 19.552Z"
                fill="#4F5260"
            />
            <path
                d="M53.0356 31.4662L49.4555 24.2501H45.418V31.4662H41.4141V11.4207H50.7462C54.5251 11.4207 57.6454 13.5098 57.6454 17.7791C57.6454 20.7834 56.3546 22.6785 53.8091 23.6775L57.6454 31.4662H53.0356ZM50.6576 15.3138H45.418V20.4696H50.6576C52.5183 20.4696 53.5217 19.6095 53.5217 17.8629C53.5193 16.0589 52.4345 15.3138 50.6576 15.3138Z"
                fill="#4F5260"
            />
            <path
                d="M77.2841 31.4662L71.8457 21.7872L68.6368 25.5678V31.4662H64.6328V11.4207H68.6392V17.1178C68.6392 17.8629 68.6104 19.667 68.5817 20.2994C68.8691 19.8395 69.6114 18.9267 70.1574 18.2654L75.7682 11.4231H80.6055L74.7385 18.3517L82.0927 31.4686H77.2841V31.4662Z"
                fill="#4F5260"
            />
            <path
                d="M93.0391 31.7802C89.6913 31.7802 86.7721 30.3786 85.2515 28.1434L88.1443 25.5679C89.5476 27.1994 91.3508 27.8559 93.269 27.8559C95.6421 27.8559 96.7604 27.1994 96.7604 25.6829C96.7604 24.3939 96.0756 23.819 92.2967 22.9613C88.6041 22.1012 86.0297 20.9296 86.0297 16.9742C86.0297 13.3398 89.2339 11.1045 93.1851 11.1045C96.3054 11.1045 98.5948 12.2784 100.484 14.255L97.5938 17.0628C96.3054 15.7475 94.8758 15 93.0415 15C90.8934 15 90.1798 15.9152 90.1798 16.8041C90.1798 18.0643 91.0371 18.4668 94.2173 19.2071C97.3926 19.9521 100.915 21.0422 100.915 25.3954C100.913 29.2023 98.5086 31.7802 93.0391 31.7802Z"
                fill="#4F5260"
            />
            <path
                d="M149.65 16.3657C149.65 15.5032 149.267 14.8779 147.687 14.8779H137.332V17.899H147.543C149.219 17.899 149.65 17.2282 149.65 16.3657Z"
                fill="#4F5260"
            />
            <path
                d="M120.36 3.80225V9.50902H126.067V33.3759H120.36V39.0802H137.339V33.3759H131.817V9.55454H147.543C152.143 9.55454 155.258 12.0006 155.258 16.3202C155.258 20.1559 152.382 23.2249 147.876 23.2249H137.329V28.9676H143.077V28.9772H147.873C155.361 28.9772 161.006 23.5364 161.006 16.3202C161.006 8.9508 155.469 3.80464 147.538 3.80464H120.36V3.80225Z"
                fill="#4F5260"
            />
            <path d="M111.483 0V42.8822" stroke="black" />
        </svg>
    )
}

export default Parks
